import { HStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { TextBodyBold2 } from '../common/Text'
import Image from '../common/Image'

export type FooterSupportProps = BoxProps & {}

const FooterSupport: React.FC<FooterSupportProps> = ({ ...others }) => {
  return (
    <>
      <Box {...others}>
        <TextBodyBold2 localizeKey="nav__title__credit" fontSize="12px" textAlign="left" mb="20px" />
        <HStack spacing="20px">
          <Image src="/images/footer_supported-01.png" w="94px" h="80px" />
          <Image src="/images/footer_supported-02.png" w="94px" h="80px" />
        </HStack>
      </Box>
    </>
  )
}

export default FooterSupport
